// The client portal sign-in address (server: firmSettings.portalBaseUrl — env PORTAL_BASE_URL, else
// Admin → Companies → Workspace → Client portal address, else the public base URL + /portal).
import { useEffect, useState } from 'react';
import { ctrlplaneApi } from './api/ctrlplane';

/** { url: '' while loading or when nothing resolves, loaded } */
export function usePortalAddress(): { url: string; loaded: boolean } {
  const [state, setState] = useState<{ url: string; loaded: boolean }>({ url: '', loaded: false });
  useEffect(() => {
    let live = true;
    ctrlplaneApi.portalSettings()
      .then(s => { if (live) setState({ url: String(s?.portalBaseEffective || ''), loaded: true }); })
      .catch(() => { if (live) setState({ url: '', loaded: true }); });
    return () => { live = false; };
  }, []);
  return state;
}
